import styled from 'styled-components';

const PageContainer = styled.div`
  position: relative;
  padding-top: 0.8rem;
  padding-bottom: 1.25rem;
`;

export default PageContainer;



// WEBPACK FOOTER //
// ./src/components/PageContainer.js